import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 via-cream-100 to-brown-50">
      {/* Header */}
      <div className="sticky top-0 z-10 backdrop-blur-lg bg-white/60 border-b border-cream-300/50 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-brown-600 hover:text-brown-900 transition-colors text-sm sm:text-base"
          >
            <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
        <div className="backdrop-blur-sm bg-white/40 rounded-xl sm:rounded-2xl border border-cream-300/50 p-6 sm:p-8 md:p-10">
          
          {/* Title */}
          <div className="mb-8 sm:mb-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-3 sm:mb-4">
              Privacy Policy
            </h1>
            <p className="text-sm sm:text-base text-brown-600">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>

          {/* Content */}
          <div className="prose max-w-none space-y-6 sm:space-y-8 text-brown-800">
            
            <section>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-brown-900 mb-3 sm:mb-4">
                1. What We Collect
              </h2>
              <p className="text-sm sm:text-base leading-relaxed mb-3">
                We only collect the data necessary to provide and secure our academic services:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm sm:text-base ml-4 sm:ml-6">
                <li><strong>Account Info:</strong> Name and email address when you sign up.</li>
                <li><strong>Your Material:</strong> Textbook images, extracted text, and AI study outputs.</li>
                <li><strong>Usage Data:</strong> Device type, browser activity, and minimal operational cookies.</li>
                <li><strong>Payments:</strong> Secured via Paystack (we do not store card details).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-brown-900 mb-3 sm:mb-4">
                2. How We Use and Share Data
              </h2>
              <p className="text-sm sm:text-base leading-relaxed mb-3">
                Your information is used strictly to run the textbook summary features. <strong>We do not sell your data.</strong> To operate our service, we securely share data with these trusted infrastructure partners:
              </p>
              <ul className="list-disc list-inside space-y-2 text-sm sm:text-base ml-4 sm:ml-6">
                <li><strong>Supabase:</strong> Safe account authentication and database architecture.</li>
                <li><strong>Gemini / OpenAI:</strong> Intelligent systems running text extraction and quiz generations.</li>
                <li><strong>Vercel & Paystack:</strong> Web hosting structure and payment verification.</li>
              </ul>
              <p className="text-sm sm:text-base leading-relaxed mt-3 italic text-brown-600">
                Note: We do not use your personal documents or uploaded textbook pages to train AI models.
              </p>
            </section>

            <section>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-brown-900 mb-3 sm:mb-4">
                3. Security & Data Retention
              </h2>
              <p className="text-sm sm:text-base leading-relaxed">
                We guard your profile with industry-standard HTTPS/TLS encryption and Supabase database row-level security. Your uploaded learning materials and profile are kept until you choose to delete your account. Simple activity logs clear automatically after 90 days, while payment history is stored to meet financial compliance rules.
              </p>
            </section>

            <section>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-brown-900 mb-3 sm:mb-4">
                4. Your Rights & Age Rules
              </h2>
              <p className="text-sm sm:text-base leading-relaxed">
                You retain complete rights to view, fix, export, or permanently delete your account details at any time. Our service is designed strictly for students aged 13 and older; we immediately clear any profiles discovered to belong to younger children.
              </p>
            </section>

            <section>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-brown-900 mb-3 sm:mb-4">
                5. Contact Us
              </h2>
              <p className="text-sm sm:text-base leading-relaxed mb-4">
                If you have questions about your data or want to request a deletion, reach out to our desk:
              </p>
              <div className="bg-cream-100/50 rounded-lg p-4 sm:p-6 border border-cream-300/50">
                <p className="text-sm sm:text-base text-brown-800 mb-2">
                  <strong>Privacy & Support Email:</strong> petermikel366@gmail.com
                </p>
                <p className="text-sm sm:text-base text-brown-800">
                  <strong>Expected Response:</strong> Within 48 hours
                </p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;